import _ from 'lodash'

export default {

    props: {
        dataInteraction: {
            type: Object,
        },
        dataOption: {
            type: Object,
        },
        maxLength: {
            type: Number,
            default: 60
        }
    },

    computed: {
        style() {
            const style = {}
            const item = this.dataOption ? this.dataOption : this.dataInteraction

            _.forEach(item.estilo, (val, key) => {
                style[key] = val
            })

            return style
        },
    },

    methods: {
        get(attr) {
            const item = this.dataInteraction

            if (!item.estilo ||
                !item.estilo[attr] ||
                !item.estilo[attr].color)
                return false

            return item.estilo[attr].color
        },

        // set({color, attr}) {
        //     const style = _.cloneDeep(this.style)
        //     style[attr].color = color
        //     const data = {
        //         estilo: style
        //     }
        //
        //     this.$store.commit('SET_INTERACTION_DATA', {
        //         interactionId: this.dataInteraction.id,
        //         data
        //     })
        //     this.setTimeout({
        //         interaction: this.dataInteraction,
        //         data
        //     })
        // },

        setTimeout({interaction, option, data}) {
            if (this.timeout)
                clearTimeout(this.timeout)

            this.timeout = setTimeout(() => this.commit({interaction, option, data}), 600)
        },

        commit({interaction, option, data}) {
            const payload = {
                advertisingId: interaction.campanhaId,
                interactionId: interaction.id,
                optionId: option ? option.id : null,
                data,
            }

            if (option)
                return this.$api.interactions.options.edit(payload)

            this.$api.interactions.update(payload)
        },

        store(option) {
            const options = _.cloneDeep(this.dataInteraction.opcoes)
            const index = _.findIndex(options, (opt) => {
                return opt.id === option.id
            })
            options[index] = option

            this.$store.commit('SET_INTERACTION_OPTIONS', {
                interactionId: this.dataInteraction.id,
                data: options
            })
        }
    },

    mixins: []

}
